import React from "react";

export const Loading = () => {
    return (
        <div className="App-loading">
            <div className="App-logo" title="Zimzee" />
        </div>
    );
};